// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1EFVZ","approved":"Status_approved__2Icld","rejected":"Status_rejected__3yvVp","expired":"Status_expired__1b9di","label":"Status_label__Xj4ex"};